import { ExclamationCircleFilled } from "@ant-design/icons";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button } from "@impero-com/ui";
import { Typography } from "antd";

import * as theme from "./PopoverContent.css";

const { Text } = Typography;

interface PopoverContentProps {
    onRemove: () => void;
    onCancel: () => void;
    warnLabel: string;
}
export function PopoverContent({
    onRemove,
    onCancel,
    warnLabel,
}: PopoverContentProps) {
    const { t } = useTranslation();
    return (
        <div className={theme.root}>
            <div className={theme.warnText}>
                <ExclamationCircleFilled className={theme.warnIcon} />
                <Text>{warnLabel}</Text>
            </div>
            <div className={theme.buttons}>
                <Button variant="default" onClick={onCancel}>
                    {t(
                        "ControlTestingActivityView_SampleDrawer_Warn_CancelButton"
                    )}
                </Button>
                <Button variant="primary" onClick={onRemove}>
                    {t(
                        "ControlTestingActivityView_SampleDrawer_Warn_ConfirmButton"
                    )}
                </Button>
            </div>
        </div>
    );
}
